// frontend-react/src/utils/validation.js
export const safeArray = (data) => {
  // Si es null o undefined, devolver array vacío
  if (!data) return [];
  
  // Si ya es un array, devolverlo
  if (Array.isArray(data)) return data;
  
  // Si es un objeto paginado de Django REST Framework (tiene 'results')
  if (data.results && Array.isArray(data.results)) {
    return data.results;
  }
  
  // Si es un objeto pero no tiene results, devolver array vacío
  return [];
};

export const safeMap = (array, callback) => safeArray(array).map(callback);
export const safeReduce = (array, callback, initialValue = 0) =>
  safeArray(array).reduce(callback, initialValue);
export const safeFilter = (array, callback) =>
  safeArray(array).filter(callback);
export const safeLength = (array) => safeArray(array).length;
